import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import {
  EcommerceWebProcessKickoff,
  EcommerceWebProcessStack,
  EcommerceWebProcessUIUX,
  EcommerceWebProcessFrontend,
  EcommerceWebProcessQuality,
  EcommerceWebProcessLaunch,
} from "../../../app-constants";
import BgImg from "../../images/services-usa/web-portal/web_portal_process.webp";
import { Link } from "gatsby";

function Ecommercewebprocess() {
  return (
    <section
      className="ecommerce_web_process text_white p-100"
      style={{
        backgroundImage: `url(${BgImg})`,
        backgroundRepeat: "no-repeat",
      }}
    >
      <Container>
        <Row>
          <Col
            xs={12}
            md={10}
            lg={9}
            xl={8}
            xxl={6}
            className="m-auto text-center"
          >
            <h2>
              Our <span>Web Portal Development</span> Process
            </h2>
            <p>
              At TekRevol, our streamlined and proven web portal development
              process ensures we deliver high-quality, reliable, and efficient
              web portals that meet our clients' unique needs. From initial
              planning to final deployment, we prioritize precision and
              excellence at every stage.
            </p>
          </Col>
        </Row>
        <Row className="mt-3 mt-md-4">
          <Col xs={12} md={6} lg={6} xl={4} xxl={4} className="mb-4">
            <div className="ecomm_process_box">
              <div className="ecomm_box_flex">
                <div className="ecomm_num">
                  01
                  <h5>Planning</h5>
                </div>
                <div className="ecom_box_icon">
                  {EcommerceWebProcessKickoff}
                </div>
              </div>
              <p>
                We meticulously gather requirements and define the project scope
                to set a strong foundation.
              </p>
            </div>
          </Col>
          <Col xs={12} md={6} lg={6} xl={4} xxl={4} className="mb-4">
            <div className="ecomm_process_box">
              <div className="ecomm_box_flex">
                <div className="ecomm_num">
                  02
                  <h5>Design</h5>
                </div>
                <div className="ecom_box_icon">{EcommerceWebProcessStack}</div>
              </div>
              <p>
                Our team creates intuitive and visually appealing designs
                tailored to your brand and user needs.
              </p>
            </div>
          </Col>
          <Col xs={12} md={6} lg={6} xl={4} xxl={4} className="mb-4">
            <div className="ecomm_process_box">
              <div className="ecomm_box_flex">
                <div className="ecomm_num">
                  03
                  <h5>Iterative Development</h5>
                </div>
                <div className="ecom_box_icon">{EcommerceWebProcessUIUX}</div>
              </div>
              <p>
                We develop the portal in iterative cycles, allowing for
                continuous improvements and feature enhancements.
              </p>
            </div>
          </Col>
          <Col xs={12} md={6} lg={6} xl={4} xxl={4} className="mb-xl-0 mb-4">
            <div className="ecomm_process_box">
              <div className="ecomm_box_flex">
                <div className="ecomm_num">
                  04
                  <h5>Portal Integration</h5>
                </div>
                <div className="ecom_box_icon">
                  {EcommerceWebProcessFrontend}
                </div>
              </div>
              <p>
                We seamlessly integrate custom and third-party tools to ensure
                comprehensive functionality.
              </p>
            </div>
          </Col>
          <Col xs={12} md={6} lg={6} xl={4} xxl={4} className="mb-md-0 mb-4">
            <div className="ecomm_process_box">
              <div className="ecomm_box_flex">
                <div className="ecomm_num">
                  05
                  <h5>QA and Testing</h5>
                </div>
                <div className="ecom_box_icon">
                  {EcommerceWebProcessQuality}
                </div>
              </div>
              <p>
                Our rigorous testing process ensures the portal is secure,
                reliable, and performs optimally.
              </p>
            </div>
          </Col>
          <Col xs={12} md={6} lg={6} xl={4} xxl={4}>
            <div className="ecomm_process_box">
              <div className="ecomm_box_flex">
                <div className="ecomm_num">
                  06
                  <h5>Deployment and Setup</h5>
                </div>
                <div className="ecom_box_icon">{EcommerceWebProcessLaunch}</div>
              </div>
              <p>
                We efficiently deploy the portal and provide complete setup
                support to ensure a smooth launch.
              </p>
            </div>
          </Col>
        </Row>
        <Row className="justify-content-center text-center">
          <Col
            xs={12}
            md={12}
            lg={12}
            xl={12}
            xxl={12}
            className="mt-3 mt-md-5"
          >
            <Link
              to="/contact"
              className="border_btn"
              aria-label="TekRevol Contact"
            >
              Learn More on Web Portal Development
            </Link>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Ecommercewebprocess;
